import API from "@services/root/rootApi";
import { Dispatch, SetStateAction } from "react";

export const postImportLicense = async (
  accountId: string,
  data: FormData,
  setProgress: Dispatch<SetStateAction<number>>
) => {
  const response = await API.post(
    `/symphony-api/license/import?accountId=${accountId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.progress ?? 0) * 100;
        setProgress(progress);
      },
    }
  );
  return response;
};

export enum ListLicenseException {
  AllowsToUseAVISPLHostedMCUs = "Allows to use AVI-SPL hosted MCUs",
  AllowsToUseAVISPLHostedAudioConferenceService = "Allows to use AVI-SPL hosted audio conference service",
  CanRequestSiteCertificate = "Can request site certificate",
  AllowsToRequestProducerAttendanceForScheduledMeetings = "Allows to request producer attendance for scheduled meetings",
  AllowsMeetingRecording = "Allows meeting recording",
}
